import { ListItem, Button, ListItemText, Divider, List } from '@mui/material';
import { t } from 'i18next';
import { Fragment } from 'react';
import { InvoiceGroup } from 'src/shared/models/invoiceGroup/invoiceGroup';

type UserRenderInvoiceGroupsListProps =
  | {
      invoiceGroupList: InvoiceGroup[];
      onAdd: (item: InvoiceGroup) => void;
      onRemove?: never;
    }
  | {
      invoiceGroupList: InvoiceGroup[];
      onRemove: (id: number) => void;
      onAdd?: never;
    };

export const UserRenderInvoiceGroupsList = (props: UserRenderInvoiceGroupsListProps) => {
  const { invoiceGroupList, onAdd, onRemove } = props;
  return (
    <List dense sx={{ m: 0, p: 0 }}>
      {invoiceGroupList.map((item) => (
        <Fragment key={item.owner_id}>
          <ListItem
            disableGutters
            secondaryAction={
              onAdd ? (
                <Button variant='contained' disableElevation size='small' onClick={() => onAdd?.(item)}>
                  {t('common:button.choose')}
                </Button>
              ) : (
                <Button variant='outlined' size='small' onClick={() => onRemove?.(item.owner_id)}>
                  {t('common:button.undo')}
                </Button>
              )
            }
          >
            <ListItemText
              primary={item.name}
              sx={{
                marginLeft: 2,
                marginRight: 2,
              }}
            />
          </ListItem>
          <Divider orientation='horizontal' flexItem component='li' sx={{ my: 0.5 }} />
        </Fragment>
      ))}
    </List>
  );
};
